// extracted by mini-css-extract-plugin
module.exports = {"banner-picture":"banner-picture-659c21e2c6e04d0a86e3b914454feb5c"};